import StepThreeComponent from './three.component'

export default StepThreeComponent;
